import { Instance, SnapshotOut, types } from 'mobx-state-tree';
import { withSetPropAction } from 'src/models/extensions/withSetPropAction';
import { OperatorInfo } from 'src/models/operator-info/OperatorInfo';

import { SubContentInfos } from './SubContent';

/**
 * # Business
 *
 * Business을 설명하세요.
 */
export const Business = types
  .model('Business')
  .props({
    businessSid: types.maybeNull(types.number),
    bnCatCd: types.maybeNull(types.number),
    bnSubCatCd: types.maybeNull(types.number),
    pipelineCd: types.maybeNull(types.string),
    title: types.maybeNull(types.string),
    useYn: types.optional(types.boolean, true),
    delYn: types.maybeNull(types.boolean),
    ordr: types.maybeNull(types.number),
    summary: types.maybeNull(types.string),
    descript: types.maybeNull(types.string),
    link: types.maybeNull(types.string),
    thumbPath: types.maybeNull(types.string),
    detailPath: types.maybeNull(types.array(types.string)),
    regDt: types.optional(types.maybeNull(types.number), 0),
    updDt: types.optional(types.maybeNull(types.number), 0),
    regUser: types.maybeNull(OperatorInfo),
    updUser: types.maybeNull(OperatorInfo),
    lang: types.maybeNull(types.string),
    subContentInfos: types.maybeNull(types.array(SubContentInfos)),
  })
  .volatile(() => ({
    // 썸네일
    thumbPathFiles: [] as File[],
    deleteThumbPathFiles: [] as string[],
    // 상세 이미지
    detailPathFiles: [] as File[],
    deleteDetailPathFiles: [] as string[],
  }))
  .actions(withSetPropAction);

// --------------------------------------------------------------------------
type TBusiness = Instance<typeof Business>;
type TBusinessSnapshot = SnapshotOut<typeof Business>;

export interface IBusiness extends TBusiness {}
export type TBusinessKeys = keyof TBusinessSnapshot & string;
export interface IBusinessSnapshot extends TBusinessSnapshot {}
export const createBusiness = () => types.optional(Business, {} as TBusiness);
